import { Gateway, GatewayPaymentType } from '../types/gateway'

// A gateway's payment type decides whether the hotel collects from the guest (CASH) or a
// provider guarantees the amount and pays the hotel later (BNPL). The server decides who may
// change it; the form only has to avoid sending it when the user did not touch it, so that
// saving an unrelated edit never rewrites it.

// Gateway types whose provider guarantees the amount. Mirrors asset's bnplGatewayTypes.
const BNPL_GATEWAY_TYPES = ['Tara']

export const supportsBnpl = (gatewaysType: string) =>
  BNPL_GATEWAY_TYPES.includes(gatewaysType)

// The payment-type select is only worth showing where there is a choice, or where the
// gateway is already BNPL and the user needs to see it.
export const showsPaymentType = (
  gatewaysType: string,
  paymentType?: GatewayPaymentType
) => supportsBnpl(gatewaysType) || paymentType === 'BNPL'

// paymentTypeToSend returns the value to send, or undefined to leave the stored value alone.
// On create there is no stored value, so anything chosen is sent and an untouched form
// sends nothing (the server stores CASH).
export const paymentTypeToSend = (
  stored: GatewayPaymentType | undefined,
  chosen: GatewayPaymentType | undefined
) => (chosen && chosen !== stored ? chosen : undefined)

// gatewayInput builds the mutation input from the form values: it drops the read-only
// displayEntityCode and includes paymentType only when paymentTypeToSend says so.
export const gatewayInput = (
  values: Gateway,
  storedPaymentType?: GatewayPaymentType
) => {
  const { displayEntityCode, paymentType, ...basicDetails } =
    values.basicDetails
  const toSend = paymentTypeToSend(storedPaymentType, paymentType)

  return {
    ...values,
    basicDetails: toSend
      ? { ...basicDetails, paymentType: toSend }
      : basicDetails
  }
}
